
<template>
  <ul
    :class="{'subMenu':subMenuS}"
    class="main-menu"
    @mouseleave="subMenuS=true"
    @mouseover="subMenuS=false"
  >
    <li
      v-for="(menu,index) in menuMainJson"
      v-if="checkPermission(menu)"
      :class="[{ active: $route.path.includes(menu.classRoute)}]"
      :key="index"
      class
    >
      <menu-item :name="$t(menu.text)"
                 :icon="menu.icon"
                 :link="menu.link" />
    </li>
  </ul>
</template>
<script>
import MenuItem from './MenuItem'
import MenuHeader from './MenuHeader'
import SubMenu from '@/components/app/user/partials/navbar/web/subMenu'
import menuMainJson from '@/components/app/user/partials/navbar/mainMenu.json'
import { mapState } from 'vuex'

export default {
	name: 'main-menu',
	components: { SubMenu, MenuItem, MenuHeader },
	data () {
		return {
			menuMainJson: menuMainJson,
			subMenuS: false
		}
	},
	computed: {
		...mapState('User', ['permissions', 'user'])
	},
	methods: {
		checkPermission (menu) {
			//  return true
			if (menu.permission) {
				let permission = this.permissions.find(
					perm => perm.permissionName === menu.permission.name
				)

				if (permission) {
					if (this.user.id === this.user.saasApp.adminId) return true
					let hasPermission = menu.permission.actions.some(
						action => permission.p[action]
					)
					if (hasPermission) return true
				} else return false
			} else return true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/mainMenu/index.vue